export const mockData = {
  hero: {
    announcement: "Now Live in Dubai, Abu Dhabi",
    title: "Convenience, evolved.",
    subtitle: "Grabo.ai brings AI-powered, autonomous retail to offices, universities, gyms, hospitals, and residential towers - giving your community instant access to everyday essentials with a clean, high-tech experience.",
    videoUrl: "https://customer-assets.emergentagent.com/job_tapgrabgo/artifacts/rwfbvb38_Grabo%20-%20v2.mp4",
    primaryCTA: "Book a Pilot",
    audienceTags: ["Offices", "Co-Working", "Universities", "Hospitals", "Gyms", "Residential"]
  },
  
  whatIsGrabo: {
    title: "What is Grabo.ai?",
    description: "Grabo.ai installs and operates autonomous retail points that blend beautifully into premium locations. People tap in, grab what they need, and walk away — and our AI handles everything behind the scenes.",
    imagePlaceholder: "https://customer-assets.emergentagent.com/job_tapgrabgo/artifacts/u0h71d47_What%20is%20Grabo.png"
  },
  
  howItWorks: {
    title: "How it Works",
    subtitle: "Simple, elegant, and effortless",
    steps: [
      {
        id: 1,
        icon: "tap",
        title: "Tap to unlock",
        description: "Use card or mobile to unlock the smart machine."
      },
      {
        id: 2,
        icon: "hand",
        title: "Grab what you need",
        description: "Computer vision and smart sensors instantly recognize every item."
      },
      {
        id: 3,
        icon: "zap",
        title: "And go",
        description: "No checkout, no queue, no scanning. You're already done."
      },
      {
        id: 4,
        icon: "brain",
        title: "AI handles the rest",
        description: "Inventory syncs live. Products adapt based on what your community actually uses."
      }
    ]
  },
  
  benefits: {
    title: "Benefits for Your Location",
    subtitle: "Quality, convenience, and an elevated experience",
    items: [
      {
        id: 1,
        title: "A premium amenity for your community",
        description: "Modern, high-tech convenience for employees, students, residents, or patients."
      },
      {
        id: 2,
        title: "Always open, always available",
        description: "24/7 access to essentials without staffing or supervision."
      },
      {
        id: 3,
        title: "A clean, sleek retail experience",
        description: "Designed to complement modern offices, campuses, and facilities."
      },
      {
        id: 4,
        title: "Smart product selection",
        description: "Shelves update based on what people actually buy in your location."
      },
      {
        id: 5,
        title: "Hassle-free operations",
        description: "You don't manage anything. We install, stock, operate, and maintain everything."
      },
      {
        id: 6,
        title: "Trusted & secure",
        description: "Privacy-first computer vision and encrypted payments."
      }
    ]
  },
  
  useCases: {
    title: "Designed for Your Space",
    subtitle: "Premium convenience for premium locations",
    cases: [
      {
        id: 1,
        icon: "building",
        title: "Offices & Corporate Campuses",
        description: "Quick access to snacks, beverages, and essentials during busy workdays.",
        imagePlaceholder: "https://customer-assets.emergentagent.com/job_tapgrabgo/artifacts/hy0897io_Office%202.png"
      },
      {
        id: 2,
        icon: "users",
        title: "Co-Working Spaces",
        description: "Modern convenience for flexible workspaces and growing communities.",
        imagePlaceholder: "https://customer-assets.emergentagent.com/job_tapgrabgo/artifacts/y30hit09_Co-Working.png"
      },
      {
        id: 3,
        icon: "graduation-cap",
        title: "Universities & Schools",
        description: "Students can grab something between classes without queues.",
        imagePlaceholder: "https://customer-assets.emergentagent.com/job_tapgrabgo/artifacts/f6knxcg2_Student%20Lounge.png"
      },
      {
        id: 4,
        icon: "heart-pulse",
        title: "Hospitals & Healthcare Facilities",
        description: "Staff and visitors get 24/7 convenience in a calm, clean interface.",
        imagePlaceholder: "https://customer-assets.emergentagent.com/job_tapgrabgo/artifacts/bc5otjh8_Hospital.png"
      },
      {
        id: 5,
        icon: "dumbbell",
        title: "Gyms & Fitness Centers",
        description: "Protein drinks, bars, hydration, accessories available instantly.",
        imagePlaceholder: "https://customer-assets.emergentagent.com/job_tapgrabgo/artifacts/jwom8qon_Gym.png"
      },
      {
        id: 6,
        icon: "home",
        title: "Residential Towers",
        description: "A premium amenity your residents will love.",
        imagePlaceholder: "https://customer-assets.emergentagent.com/job_tapgrabgo/artifacts/g2q0hoqt_Residential%20Building.png"
      }
    ]
  },
  
  technology: {
    title: "Built on Intelligent Technology",
    subtitle: "Powerful simplicity",
    imageUrl: "https://customer-assets.emergentagent.com/job_tapgrabgo/artifacts/t3ywl6yr_Intelligent%20Tech%2016-9.png",
    features: [
      {
        id: 1,
        title: "AI-powered product recognition",
        description: "Computer vision identifies items instantly"
      },
      {
        id: 2,
        title: "Cashless, secure access",
        description: "Encrypted payments and secure authentication"
      },
      {
        id: 3,
        title: "Real-time stocking and monitoring",
        description: "Live inventory sync and automated restocking alerts"
      },
      {
        id: 4,
        title: "Beautifully integrated hardware",
        description: "Sleek design that enhances your space"
      }
    ]
  },
  
  about: {
    title: "About Grabo.ai",
    description: "Born in the UAE, Grabo.ai is building the future of AI-powered retail for premium locations. We focus on simplicity, clean design, and experiences that feel effortless."
  },
  
  finalCTA: {
    title: "Bring Grabo.ai to Your Space",
    subtitle: "Let's explore how an autonomous grab-and-go point can elevate your location.",
    buttonText: "Book a Pilot",
    alternativeText: "Or email us at hello@grabo.ai"
  },
  
  footer: {
    tagline: "Tap. Grab. Go.",
    phone: "+971 585 358 007",
    email: "hello@grabo.ai",
    location: "UAE",
    copyright: "© 2025 Grabo.ai. All rights reserved."
  }
};
